export default {
    modalGenerateImageVariations: {
        imageAIHeader: 'Opret billede ved hjælp af AI',
        requestFailed: 'Anmodningen mislykkedes',
        describeYourImage: 'Beskriv dit billede',
        numberOfVariations: 'Antal variationer',
        chooseStyle: 'Vælg din billedstil',
        descriptionPlaceholder: '(eg) En mark med sennepsblomster på en sommerdag med egetræer',
        clear: 'Ryd',
        generate: 'Generer',
        seeAll: 'Se alle',
        tryAnExample: 'Prøv et eksempel',
        tryAnother: 'Prøv en anden',
    },
};
